<template>
	<div class="right">
		<div class="box" @click="option(0)">
			<img class="vr_img" src="../static/home/icon_VR.png" alt="">
			<div class="box_text">
				<span v-if="lang==1">虚拟景区</span>
				<span v-if="lang==2">Virtual</span>
				<span v-if="lang==3">仮想観光地</span>
				<span v-if="lang==4">가상 관광지</span>
			</div>
		</div>
		<div class="box" @click="option(1)">
			<img class="kefu_img" src="../static/home/kefu.png" alt="">
			<div class="box_text">
				<span v-if="lang==1">咨询热线</span>
				<span v-if="lang==2">Hotline</span>
				<span v-if="lang==3">ねっせん</span>
				<span v-if="lang==4">상담 핫라인</span>
			</div>
		</div>
		<div class="box" @click="option(2)">
			<img class="news_img" src="../static/home/new.png" alt="">
			<div class="box_text">
				<span v-if="lang==1">新闻动态</span>
				<span v-if="lang==2">News</span>
				<span v-if="lang==3">ニュースの動き</span>
				<span v-if="lang==4">뉴스 동향</span>
			</div>
		</div>
		<div class="box" @click="option(3)">
			<img class="ding_img" src="../static/home/oline.png" alt="">
			<div class="box_text">
				<span v-if="lang==1">在线预订</span>
				<span v-if="lang==2">book</span>
				<span v-if="lang==3">購読する</span>
				<span v-if="lang==4">온라인 가입</span>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				lang:1,	//语言
			}
		},
		created() {
			this.lang = JSON.parse(localStorage.getItem("langs")) || 1
		},
		methods:{
			option(e){
				if(e==0){
					window.open('https://www.720yun.com/vr/182jO7kkva8',"_blank");
				}
				if(e==1){
					if(this.$route.name == 'contact'){
						this.$router.replace('/refresh')
					}else{
						this.$router.push({name:'contact',query:{nums:0}})
					}
				}
				if(e==2){
					if(this.$route.name == 'news'){
						this.$router.replace('/refresh')
					}else{
						this.$router.push({name:'news',query:{nums:0}})
					}
				}
				if(e==3){
					if(this.$route.name == 'online'){
						this.$router.replace('/refresh')
					}else{
						this.$router.push({name:'online',query:{nums:0}})
					}
				}
			}
		}
	}
</script>

<style scoped lang="less">
	.right{
		width: 108px;
		padding: 10px 0;
		position: absolute;
		z-index: 9;
		right: 0;
		top: 50%;
		transform:translateY(-50%);
		border-radius: 10px;
		background-color: rgba(0, 0, 0, .7);
		
		display: flex;
		flex-wrap: wrap;
		align-content: space-around;
	}
	
	.box{
		width: 108px;
		margin: 10px 0;
		cursor:pointer;
	}
	
	.vr_img{
		width: 60px;
		height: 60px;
		display: block;
		margin: auto;
	}
	.box_text{
		font-size: 14px;
		margin-top: 8px;
		text-align: center;
		color: #fff;
	}
	.kefu_img{
		width: 60px;
		height: 60px;
		display: block;
		margin: auto;
	}
	.news_img{
		width: 60px;
		height: 60px;
		display: block;
		margin: auto;
	}
	.ding_img{
		width: 60px;
		height: 60px;
		display: block;
		margin: auto;
	}
	
	
</style>